import * as React from "react"
import classNames from "classnames"
import { ActionAnchor } from "@tenforce/toolbox-button-push-react"

import env from "../../../env"

export default function LauncherPage(): JSX.Element {
    const tfAppLogo = `${env.applicationStaticPath}/App_Themes/tf_app_logo_152.png`
    const launcherPageData = env.launcherPageData
    const hash = window.location.hash

    let webAppRedirectUri = launcherPageData.WebAppRedirectUri
    let tenForceDeepLinkUri = launcherPageData.TenForceDeepLinkUri

    if (hash && hash !== "#") {
        tenForceDeepLinkUri = tenForceDeepLinkUri + hash
        webAppRedirectUri = webAppRedirectUri + hash
    }

    return (
        <div className="tw-flex tw-justify-center tw-items-center tw-min-h-screen">
            <div className=" tw-py-8 tw-px-1/12">
                <header className="tw-py-4 tw-px-8">
                    <ActionAnchor
                        isLabel={false}
                        id="linkToTenForceHomepage"
                        title="TenForce Homepage"
                        className="is-inverted no-underline tw-text-xl"
                        href="https://www.tenforce.com/"
                    >
                        
                    </ActionAnchor>
                </header>
                <div className="NewUI-card tw-w-full tw-p-2 bg-white">
                    <ActionAnchor
                        isLabel={false}
                        id="tenForceDeepLink"
                        title="TenForce App"
                        href={tenForceDeepLinkUri}
                        extraClasses={classNames("theme-thumb", "bg-cloud")}
                    >
                        <img
                            src={tfAppLogo}
                            alt="TF"
                            className="tw-h-auto"
                            style={{ width: "1.9rem" }}
                        />
                        <p className="tw-text-xl">
                            &nbsp;{launcherPageData.OpenInTenForceAppLabel}
                        </p>
                    </ActionAnchor>

                    <ActionAnchor
                        isLabel={false}
                        id="linkToAppStorePage"
                        href={launcherPageData.TenForceAppStoreUri}
                        title="App Store Page"
                        extraClasses={classNames("theme-thumb", "bg-cloud")}
                    >
                        <p className="tw-text-xl">
                            &nbsp;
                            {launcherPageData.DownloadTenForceAppFromStoreLabel}
                        </p>
                    </ActionAnchor>

                    <ActionAnchor
                        isLabel={false}
                        id="linkToLoginPage"
                        href={webAppRedirectUri}
                        title="Tenforce Web App"
                        extraClasses={classNames("theme-thumb", "bg-cloud")}
                    >
                        <p className="tw-text-xl">
                            &nbsp;{launcherPageData.ContinueInBrowserLabel}
                        </p>
                    </ActionAnchor>
                </div>
            </div>
        </div>
    )
}
